import { render, staticRenderFns } from "./OfflineBadge.vue?vue&type=template&id=78af7a8a&scoped=true&"
import script from "./OfflineBadge.vue?vue&type=script&lang=js&"
export * from "./OfflineBadge.vue?vue&type=script&lang=js&"
import style0 from "./OfflineBadge.vue?vue&type=style&index=0&id=78af7a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78af7a8a",
  null
  
)

export default component.exports